module.exports = __webpack_public_path__ + "img/trade-img-bjiu.47a8cf3d.png";